import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock'
import CustomAlert from '@space-lib/components/customAlert'
import useCommunityConfigurationSidebar from '@space-shell/modules/communities/communityConfigurationSidebar/hooks/useConfigurationCommunitySidebar/useCommunityConfigurationSidebar'
import { useTranslation } from 'react-i18next'

import { WarningAlert, WarningIcon, WarningLabel } from './styles'

import { COMMUNITY_TYPE } from '../../constants'
import { SubTitle } from '../headerAccessAndPrivacy/styles'

const AccessHeader = () => {
  const { community } = useCommunityConfigurationSidebar()

  const { t } = useTranslation()

  return (
    <>
      <p className='_text-gray-900 _font-weight-light _text-5 _mb-5'>
        {t('configuration_sidebar.access_and_privacy.title')}
      </p>
      {community.isLocked && (
        <WarningAlert className='_d-flex _p-4 _rounded-lg'>
          <WarningIcon icon={faClock} className='_m-0 _mr-3' />
          <WarningLabel className='_mb-0 _font-weight _text-1'>
            {t('configuration_sidebar.access_and_privacy.community_locked_alert')}
          </WarningLabel>
        </WarningAlert>
      )}
      <SubTitle className='_font-weight-bold _text-gray-900 _mb-1 _mt-5'>
        {t('configuration_sidebar.access_and_privacy.sub_title')}
      </SubTitle>
      {community.type === COMMUNITY_TYPE.PAID ? (
        <CustomAlert icon={faCircleInfo} iconClassName='fa-lg' className='_mb-5 _mt-5'>
          <p className='_mb-0 _font-weight _text-2 _text-gray-700'>
            {t('configuration_sidebar.access_and_privacy.community_privacy_alert')}
          </p>
        </CustomAlert>
      ) : (
        <p className='_font-weight _text-2 _text-gray-500 _mb-5'>
          {t('configuration_sidebar.access_and_privacy.description_v2')}
        </p>
      )}
    </>
  )
}

export default AccessHeader
